module.exports = __webpack_public_path__ + "static/img/solutionDetailPic11.3f5e91d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic11.jpg
// module id = Qcgk
// module chunks = 1